import { useQuery } from 'react-query';
import { UseCurrentLogoOptions } from './useCurrentLogo.types';
import { queryCurrentLogo } from './useCurrentLogo.query';

export const CURRENT_LOGO_QUERY_KEY = 'CURRENT_LOGO';

export const useCurrentLogo = (options?: UseCurrentLogoOptions) => {
  return useQuery<File, Error>(CURRENT_LOGO_QUERY_KEY, () => queryCurrentLogo(), {
    ...options,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
